import { computed, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { LundifySubscriptionsService } from 'src/app/core/services/lundify-subscriptions.service';

@Injectable()
export class LundifyEmailPortalFacade {
  private lundifySubscriptionsService: LundifySubscriptionsService = inject(LundifySubscriptionsService);
  private internalEmailPortalAddress: WritableSignal<string | null> = signal(null);

  hasEmailPortalAddress = computed(() => Boolean(this.internalEmailPortalAddress()));
  emailPortalAddress = computed(() => this.internalEmailPortalAddress());

  loadEmailPortalAddress(clientId: number): Observable<string> {
    return this.lundifySubscriptionsService.getEmailPortalSettings(clientId).pipe(
      map((response) => response.emailPortalAddress),
      tap((emailPortalAddress) => {
        this.internalEmailPortalAddress.set(emailPortalAddress);
      }),
    );
  }
}
